import { PRICES } from "../../data/constans";
import Tilt from "react-parallax-tilt";

const Prices = () => {
  return (
    <div id="prices" className="scroll-mt-[8vh] bg-white">
      <div className="flex min-h-[92vh] flex-col items-center justify-center py-8">
        <h1 className="text-center text-4xl font-extrabold text-blue-500 lg:text-5xl xl:text-6xl">Árak</h1>
        <div className="mx-auto mt-8 grid w-[90%] grid-cols-1 items-stretch gap-8 md:grid-cols-2 lg:mt-20 lg:grid-cols-3 lg:gap-16 xl:h-auto xl:w-[80%] xl:gap-20">
          {PRICES.map((service, index) => (
            <div key={index} className="flex h-full min-h-32 lg:min-h-40">
              <Tilt tiltReverse={true} className="w-full">
                <div className="flex h-full flex-col items-center justify-center rounded-lg border-0 border-blue-500 bg-blue-500 p-4 text-center shadow-lg shadow-blue-700 hover:shadow-xl hover:shadow-blue-800 md:space-y-4 lg:space-y-12">
                  <h3 className="text-base font-bold text-white">{service.serviceName}</h3>
                  <div className="text-base font-light text-white">{service.price.toLocaleString("hu-HU")} Ft</div>
                </div>
              </Tilt>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Prices;
